import axios from 'axios'
import store from '@/store'
import { getToken } from '@/utils/auth'
import { message } from 'ant-design-vue/lib'
import code from '@/utils/code'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 10000, // request timeout
})
// request interceptor
service.interceptors.request.use(
  (config) => {
    if (getToken()) {
      config.headers['Authorization'] = 'Bearer ' + getToken()
    }
    return config
  },
  (error) => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  },
)

// response interceptor
service.interceptors.response.use(
  (response) => {
    const res = response.data
    if (!res.code) {
      return res
    }
    if (res.code === 'MSCS0000') {
      return res.data
    } else if (code[res.code]) {
      message.error(code[res.code])
    } else {
      message.error('Error!')
    }
    return Promise.reject('error')
  },
  (error) => {
    console.log('err' + error) // for debug
    if (error.response.status === 401) {
      message.error('Error')
      store.dispatch('user/resetToken').then(() => {
        location.href = '/'
      })
    }
    if (error.response.status === 404) {
      location.href = '/'
    }
    if (error.response.status === 500) {
      location.href = '#/500'
    }
    return Promise.reject(error)
  },
)

export default service
